import { render } from "./TagUsers.vue?vue&type=template&id=0b6bed0e"
import script from "./TagUsers.vue?vue&type=script&lang=js"
export * from "./TagUsers.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./TagUsers.vue?vue&type=style&index=1&id=0b6bed0e&lang=css"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__